/*
 * File: formatDLN.ts
 * Author: Austin Robinson
 * Date Created: 12/07/2025
 * Copyright (c) DrivingDoc 2025
 */

/**
 * Formats a driver's license number by adding dashes.
 * For 10-digit DLNs, formats as XXXX-XX-XXXX.
 *
 * @param dln - The driver's license number (with or without dashes)
 * @returns Formatted DLN string
 *
 * @example
 * formatDLN('1234567890') // '1234-56-7890'
 * formatDLN('1234-56-7890') // '1234-56-7890' (already formatted)
 */
export function formatDLN(dln: string): string {
  const dlnNoDashes = dln.replace(/-/g, '');
  if (dlnNoDashes.length === 10) {
    return `${dlnNoDashes.substring(0, 4)}-${dlnNoDashes.substring(4, 6)}-${dlnNoDashes.substring(6, 10)}`;
  }
  return dln;
}